export default __webpack_public_path__ + "static/media/empty_search.e3a8adc8.gif";